export default "__VITE_ASSET__IMSmeh3T__"